import { FunctionComponent, ReactNode } from "react";

interface AuthLayoutProps {
    /** Titre de la carte (ex. « Connexion »). Optionnel pour les écrans de résultat. */
    title?: string;
    /** Sous-titre contextuel affiché sous le titre. */
    subtitle?: string;
    children: ReactNode;
}

/**
 * Encadre les pages publiques d'authentification (connexion, activation,
 * réinitialisation) avec l'identité de l'association : en-tête brandé (logo + nom
 * sur le dégradé AMC) puis un corps de carte pour le contenu spécifique de la page.
 */
export const AuthLayout: FunctionComponent<AuthLayoutProps> = ({ title, subtitle, children }) => (
    <div className="auth-page">
        <div className="auth-card">
            <div className="auth-card-header">
                <img
                    className="auth-card-logo"
                    src={`${process.env.PUBLIC_URL}/images/logo_amc.png`}
                    alt="Association Musulmane du Chablais"
                />
                <div className="auth-card-brand">Association Musulmane du Chablais</div>
            </div>
            <div className="auth-card-body">
                {title && <h1 className="auth-card-title">{title}</h1>}
                {subtitle && <p className="auth-card-subtitle">{subtitle}</p>}
                {children}
            </div>
        </div>
    </div>
);
